import React, { useCallback, useEffect, useState } from 'react'
import EmptyListPlaceholder from '../Common/EmptyListPlaceholder';
import CircularLoader from '../Common/CircularLoader';
import { VendorTipService } from '../../services/VendorTipService';
import VendorTipListForModule from './VendorTipListForModule';

interface InputProps{
    cookId: number;
}
const vendorTipService = new VendorTipService();
function VendorTipListForCook({cookId} : InputProps) {
  let [subData, setSubData] = useState<any>(null);
  let [isLoading, setIsLoading] = useState<boolean>();
  const [pageSize, setPageSize] = useState(10);

  const refreshData = useCallback(
    (pageNo: number) => {
      setIsLoading(true);
      vendorTipService
        .getAllVendorTipsForCook(cookId ,pageSize, pageSize * pageNo,{
          order: "DESC",
          field: "createdAt",
        })
        .then((data) => {
          setSubData(data);
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
        });
    },
    [cookId, pageSize]
  );

  useEffect(() => {
    refreshData(0);
  }, [refreshData]);

  return (
    <div>
      {
        isLoading && <CircularLoader/>
      }  
      {subData &&
        subData?.data &&
        Array.isArray(subData?.data) &&
        (subData?.data?.length > 0 ? (
          <VendorTipListForModule
            isLoading={isLoading}
            count={subData?.count}
            data={subData?.data}
            refreshData={refreshData}
            setPageSize={setPageSize}
            pageSize={pageSize}
          />
        ) : (
          <EmptyListPlaceholder message="No Tip Found"/>
        ))}
    </div>
  );
}

export default VendorTipListForCook
